"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

require("core-js/modules/es.weak-map.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/web.dom-collections.for-each.js");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ol = require("ol");

var _Base = _interopRequireDefault(require("ol/layer/Base"));

var _Group = _interopRequireDefault(require("ol/layer/Group"));

var _antd = require("antd");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["map", "layerGroup", "filterFunc", "titleFunc", "style", "dropdownStyle", "value", "defaultLayer", "defaultValue", "placeholder", "treeDefaultExpandAll", "onSelect", "onSelectLayer", "multiple", "treeCheckable"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var defaultTitleFunc = function defaultTitleFunc(layer) {
  return layer.get('name');
};
/**
 * TreeSelect component to allow the selection of a ol/layer Layer.
 * Additional properties not listed below can be used for this
 * component: See <u>https://ant.design/components/tree-select/</u> for 
 * more details.
 * 
 * @visibleName Layer TreeSelect
 */


var LayerTreeSelect = function LayerTreeSelect(_ref) {
  var map = _ref.map,
      _ref$layerGroup = _ref.layerGroup,
      layerGroup = _ref$layerGroup === void 0 ? map.getLayerGroup() : _ref$layerGroup,
      _ref$filterFunc = _ref.filterFunc,
      filterFunc = _ref$filterFunc === void 0 ? undefined : _ref$filterFunc,
      _ref$titleFunc = _ref.titleFunc,
      titleFunc = _ref$titleFunc === void 0 ? defaultTitleFunc : _ref$titleFunc,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {
    width: '100%'
  } : _ref$style,
      _ref$dropdownStyle = _ref.dropdownStyle,
      dropdownStyle = _ref$dropdownStyle === void 0 ? {
    maxHeight: 400,
    overflow: 'auto'
  } : _ref$dropdownStyle,
      value = _ref.value,
      defaultLayer = _ref.defaultLayer,
      _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? defaultLayer ? Array.isArray(defaultLayer) ? defaultLayer.map(function (layer) {
    return layer.ol_uid.toString();
  }) : defaultLayer.ol_uid.toString() : undefined : _ref$defaultValue,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "Select Layer" : _ref$placeholder,
      _ref$treeDefaultExpan = _ref.treeDefaultExpandAll,
      treeDefaultExpandAll = _ref$treeDefaultExpan === void 0 ? true : _ref$treeDefaultExpan,
      onSelect = _ref.onSelect,
      onSelectLayer = _ref.onSelectLayer,
      multiple = _ref.multiple,
      _ref$treeCheckable = _ref.treeCheckable,
      treeCheckable = _ref$treeCheckable === void 0 ? false : _ref$treeCheckable,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0, _react.useState)(value ? value : defaultValue),
      _useState2 = _slicedToArray(_useState, 2),
      internalValue = _useState2[0],
      setInternalValue = _useState2[1];

  if (!map.getLayerGroup().get('name')) {
    var rootLayerName = 'Layers';
    map.getLayerGroup().set('name', rootLayerName);
  }
  /**
   * Create the tree data from the input layer.
   */


  var treeDataFromLayer = (0, _react.useCallback)(function (layer) {
    var childrenTreeData = []; // if (layer instanceof OlGroupLayer) {
    //     let childLayers = layer.getLayers().getArray()
    //     childLayers = filterFunc ? childLayers.filter(filterFunc) : childLayers;
    //     childrenTreeData = childLayers.map((childLayer) => {
    //         return treeDataFromLayer(childLayer);
    //     });
    //     childrenTreeData.reverse();
    // } 

    if (layer instanceof _Group.default) {
      var childLayers = layer.getLayers().getArray();
      childLayers = filterFunc ? childLayers.filter(filterFunc) : childLayers;
      childrenTreeData = childLayers.map(function (childLayer) {
        return treeDataFromLayer(childLayer);
      });
      childrenTreeData.reverse();
    } //const key = layer.ol_uid.toString();


    var treeData = {
      //key:key,
      title: titleFunc(layer),
      value: layer.ol_uid.toString(),
      layer: layer,
      children: childrenTreeData
    };
    return treeData;
  }, [filterFunc, titleFunc]);
  /**
  * Creates TreeNodes from a given layergroup and sets the treeNodes in the state.
  * 
  * @param {ol.layer.Group} groupLayer A Layer Group
  */

  var treeDataFromLayerGroup = (0, _react.useCallback)(function (groupLayer) {
    var newTreeData = treeDataFromLayer(groupLayer); //newTreeData.children.reverse();

    setTreeData([newTreeData]);
  }, [treeDataFromLayer]); // const treeDataFromLayerGroup = useCallback((groupLayer) => {
  //     let layers = groupLayer.getLayers().getArray();
  //     layers = filterFunc ? layers.filter(filterFunc) : layers;
  //     const newTreeData = layers.map((layer) => treeDataFromLayer(layer));
  //     newTreeData.children.reverse();
  //     setTreeData(newTreeData);
  // }, [filterFunc, treeDataFromLayer]);

  var rebuildTreeData = (0, _react.useCallback)(function () {
    treeDataFromLayerGroup(layerGroup);
  }, [layerGroup, treeDataFromLayerGroup]);
  /**
   * Event Handler to handle 'change:name' event
   * 
   */

  var onLayerChangeName = (0, _react.useCallback)(function (evt) {
    if (evt.target.get('name') !== evt.oldValue) {
      if (evt.oldValue === internalValue) {
        setInternalValue(evt.target.ol_uid.toString());
      }

      rebuildTreeData();
    }
  }, [rebuildTreeData, internalValue]);
  /**
   * Register the 'change:name' event handler for the layer.
   * if the layer is a group, the related children will have 
   * also the event handler registered.
   * 
   * @param {ol.layer.Base} layerOrGroup A corresponding layer or group
   */

  var registerOnLayerChangeName = (0, _react.useCallback)(function (layerOrGroup) {
    var filterFunction = filterFunc ? filterFunc : function () {
      return true;
    };

    if (layerOrGroup instanceof _Group.default) {
      //register layer group
      if (filterFunction(layerOrGroup)) {
        layerOrGroup.on('change:name', onLayerChangeName);
      } //register childrens


      var layers = layerOrGroup.getLayers();
      layers.forEach(function (layer) {
        if (filterFunction(layer)) {
          registerOnLayerChangeName(layer);
        }
      });
    } else {
      //register leaf
      if (filterFunction(layerOrGroup)) {
        layerOrGroup.on('change:name', onLayerChangeName);
      }
    }
  }, [filterFunc, onLayerChangeName]);
  /**
   * Unregister the 'change:name' event handler for the layer.
   * if the layer is a group, the related children will have 
   * also the event handler unregistered.
   * 
   * @param {ol.layer.Base} layerOrGroup A corresponding layer or group
   */

  var unRegisterOnLayerChangeName = (0, _react.useCallback)(function (layerOrGroup) {
    var filterFunction = filterFunc ? filterFunc : function () {
      return true;
    };

    if (layerOrGroup instanceof _Group.default) {
      //unregister layer group
      if (filterFunction(layerOrGroup)) {
        layerOrGroup.un('change:name', onLayerChangeName);
      } //register childrens


      var layers = layerOrGroup.getLayers();
      layers.forEach(function (layer) {
        if (filterFunction(layer)) {
          unRegisterOnLayerChangeName(layer);
        }
      });
    } else {
      //register leaf
      if (filterFunction(layerOrGroup)) {
        layerOrGroup.un('change:name', onLayerChangeName);
      }
    }
  }, [filterFunc, onLayerChangeName]);
  /**
   * Register recursivelly the event handlers add/remove/change
   * for all the group layers.
   * 
   * Pre-definition of registerCollectionHandlers to manage circular
   * dependencies. See re-definition below
   */

  var registerCollectionHandlers = null;
  /**
   * Unregister recursivelly the event handlers add/remove/change
   * for all the group layers.
   * 
   * Pre-definition of unRegisterCollectionHandlers to manage circular
   * dependencies. See re-definition below
   */

  var unRegisterCollectionHandlers = null;
  /**
   * Event handler called once a layer is added
   * to the collection.
   * 
   * This handler will register:
   * (a) the event handlers for add/remove/change in group layer
   * (b) the 'change:visible' event handler for the layer.
   */

  var onCollectionAdd = (0, _react.useCallback)(function (evt) {
    var filterFunction = filterFunc ? filterFunc : function () {
      return true;
    };

    if (filterFunction(evt.element)) {
      if (evt.element instanceof _Group.default) {
        registerCollectionHandlers && registerCollectionHandlers(evt.element);
      }

      registerOnLayerChangeName(evt.element);
    }

    rebuildTreeData();
  }, [registerCollectionHandlers, filterFunc, rebuildTreeData, registerOnLayerChangeName]);
  /**
   * Event handler called once a layer is removed
   * from the collection.
   * 
   * This handler will unregister:
   * (a) the event handlers for add/remove/change in group layer
   * (b) the 'change:visible' event handler for the layer.
   */

  var onCollectionRemove = (0, _react.useCallback)(function (evt) {
    var filterFunction = filterFunc ? filterFunc : function () {
      return true;
    };

    if (filterFunction(evt.element)) {
      if (evt.element instanceof _Group.default) {
        unRegisterCollectionHandlers && unRegisterCollectionHandlers(evt.element);
      }

      unRegisterOnLayerChangeName(evt.element);
    }

    rebuildTreeData();
  }, [filterFunc, rebuildTreeData, unRegisterCollectionHandlers, unRegisterOnLayerChangeName]);
  /**
   * Register recursivelly the event handlers add/remove/change
   * for all the group layers.
   * 
   * @param {ol.layer.Group} groupLayer 
   */

  registerCollectionHandlers = (0, _react.useCallback)(function (groupLayer) {
    var filterFunction = filterFunc ? filterFunc : function () {
      return true;
    };
    var collection = groupLayer.getLayers();

    if (filterFunction(groupLayer)) {
      collection.on('add', onCollectionAdd);
      collection.on('remove', onCollectionRemove); //groupLayer.on('change:layers', onCollectionChangeLayers);
    } //register handler in all the child group layers


    collection.forEach(function (layer) {
      if (layer instanceof _Group.default) {
        registerCollectionHandlers(layer);
      }
    });
  }, [filterFunc, onCollectionAdd, onCollectionRemove, registerCollectionHandlers]);
  /**
   * Unregister recursivelly the event handlers add/remove/change
   * for all the group layers.
   * 
   * @param {ol.layer.Group} groupLayer 
   */

  unRegisterCollectionHandlers = (0, _react.useCallback)(function (groupLayer) {
    var filterFunction = filterFunc ? filterFunc : function () {
      return true;
    };
    var collection = groupLayer.getLayers();

    if (filterFunction(groupLayer)) {
      collection.un('add', onCollectionAdd);
      collection.un('remove', onCollectionRemove); //groupLayer.un('change:layers', onCollectionChangeLayers);
    } //register handler in all the child group layers


    collection.forEach(function (layer) {
      if (layer instanceof _Group.default) {
        unRegisterCollectionHandlers(layer);
      }
    });
  }, [filterFunc, onCollectionAdd, onCollectionRemove, unRegisterCollectionHandlers]);
  var internalOnSelect = (0, _react.useCallback)(function (value, node, extra) {
    setInternalValue(node.layer.ol_uid.toString());
    onSelect && onSelect(value, node, extra);
    onSelectLayer && onSelectLayer(node.layer);
  }, [onSelect, onSelectLayer]);

  var _useState3 = (0, _react.useState)([]),
      _useState4 = _slicedToArray(_useState3, 2),
      treeData = _useState4[0],
      setTreeData = _useState4[1];
  /**
   * Register 'change:name' for the group layer and all its
   * childrens
   */


  (0, _react.useEffect)(function () {
    registerOnLayerChangeName(layerGroup); //clean-up:

    return function () {
      return unRegisterOnLayerChangeName(layerGroup);
    };
  }, [layerGroup, registerOnLayerChangeName, unRegisterOnLayerChangeName]);
  /**
  * Register collection event handlers for the group layer and 
  * its child group layers 
  */

  (0, _react.useEffect)(function () {
    registerCollectionHandlers(layerGroup); //clean-up:

    return function () {
      return unRegisterCollectionHandlers(layerGroup);
    };
  }, [layerGroup, registerCollectionHandlers, unRegisterCollectionHandlers]);
  /**
  * rebuild the tree data
  */

  (0, _react.useEffect)(function () {
    rebuildTreeData();
  }, [rebuildTreeData]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.TreeSelect, _objectSpread({
    style: style,
    value: internalValue,
    defaultValue: defaultValue,
    dropdownStyle: dropdownStyle,
    treeData: treeData,
    placeholder: placeholder,
    treeDefaultExpandAll: treeDefaultExpandAll,
    onSelect: internalOnSelect,
    multiple: multiple,
    treeCheckable: treeCheckable
  }, otherProps)); // const treeDataFromLayer = useCallback((layer) => {
  //     let childNodes =  [];
  //     if (layer instanceof OlGroupLayer) {
  //         let childLayers = layer.getLayers().getArray()
  //         childLayers = filterFunc ? childLayers.filter(filterFunc) : childLayers;
  //         childNodes = childLayers.map((childLayer) => {
  //             return treeDataFromLayer(childLayer);
  //         });
  //         childNodes.reverse();
  //     } 
  //     const treeNode = (
  //         <TreeSelect.TreeNode 
  //             key={layer.ol_uid.toString()} 
  //             title={titleFunc ? titleFunc(layer) : layer.get('name')}
  //             ol_layer={layer}
  //         >
  //             {childNodes.length > 0 && childNodes}
  //         </TreeSelect.TreeNode>
  //     );
  //     //treeNode._ol_layer = layer;
  //     return treeNode;
  // }, [filterFunc, titleFunc]);
};

LayerTreeSelect.propTypes = {
  /**
   * The OpenLayers ol/Map having the layers to be shown
   * in the LayerTreeSelect.
   */
  map: _propTypes.default.instanceOf(_ol.Map).isRequired,

  /**
   * The OpenLayers ol/layer/Group having the layers to be shown
   * in the LayerTreeSelect.
   * If not provided, all the layers from the <u>map</u> will
   * be shown.
   */
  layerGroup: _propTypes.default.instanceOf(_Group.default),

  /**
   * Function to filter the layers to be shown in the LayerTreeSelect.
   * This function should have as parameter the layer and if it 
   * returns true, the layer will be shown; otherwise the layer
   * will not be included in the component. Check for the
   * javascript Array.filter function for additional parameters.
   * If not provided, all the layers present in the input
   * <u>layerGroup</u> will be shown.
   */
  filterFunc: _propTypes.default.func,

  /**
   * A function to change the title of the Layer to be shown
   * in the LayerTreeSelect. This function will receive as parameter
   * the layer and returns a string for the title. Some function
   * implementations should be, for example, to set the first 
   * letter of the layer name in uppercase and or to replace
   * "_" by a single space. This function will not change the layer
   * name and it will only affect how the layer name will be 
   * shown in the LayerTreeSelect.
   */
  titleFunc: _propTypes.default.func,

  /**
   * Function callback called once the user selects the layer in the tree.
   * This function will have as parameter the selected layer.
  */
  onSelectLayer: _propTypes.default.func,

  /**
   * The initial selected value(s)
   * @ignore
   */
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),

  /**
   * The initial selected layer(s)
   */
  defaultLayer: _propTypes.default.oneOfType([_propTypes.default.instanceOf(_Base.default), _propTypes.default.arrayOf(_propTypes.default.instanceOf(_Base.default))]),

  /**
   * To set the CSS style of the dropdown menu.
   * 
   */
  dropdownStyle: _propTypes.default.object,

  /**
   * Placeholder of the tree select input
   */
  placeholder: _propTypes.default.string,

  /**
   * A CSS style of the tree select input.
   */
  style: _propTypes.default.object,

  /**
   * Whether to expand all treeNodes by default
   */
  treeDefaultExpandAll: _propTypes.default.bool,

  /**
   * Support multiple or not, will be true when enable treeCheckable
   */
  multiple: _propTypes.default.bool,

  /**
   * Whether to show checkbox on the treeNodes
   */
  treeCheckable: _propTypes.default.bool
};
var _default = LayerTreeSelect;
exports.default = _default;